module.exports = __webpack_public_path__ + "img/jiesongji.db8532ab.png";